module.exports = __webpack_public_path__ + "static/media/status_Idle_filter.be9e8322.svg";